import type { RootState } from '@/root-store';
import { UploadedFile } from '@/shared/models/uploaded-file';

import { DriverDocType } from '../model/driver-doc-type';

const getCurrentDriver = (state: RootState) => state.drivers.driver;

const getMyDriver = (state: RootState) => state.drivers.myDriver;

const getAllDrivers = (state: RootState) => state.drivers.all;

const getDrivers = (state: RootState) => state.drivers.drivers;

const getCurrentDriverId = (state: RootState) => state.drivers.driver?.id;
const getMyDriverId = (state: RootState) => state.drivers.myDriver.id;

const getReferralCode = (state: RootState) => state.drivers.driverReferralCode;

const EMPTY_UPLOADS: Partial<Record<DriverDocType, UploadedFile<DriverDocType>>> = {};

const getUploadedDocsForCurrentDriver = (state: RootState) =>
  state.drivers.driver?.docUploads || EMPTY_UPLOADS;
const getUploadedDocsForMyDriver = (state: RootState) => state.drivers.myDriver.docUploads;

const getHourlyWorkloads = (state: RootState) =>
  state.drivers.driverWorkload?.hourlyWorkloads || null;

const getWorkloadSummary = (state: RootState) => state.drivers.driverWorkload?.summary || null;

export {
  getMyDriver,
  getCurrentDriver,
  getAllDrivers,
  getDrivers,
  getCurrentDriverId,
  getMyDriverId,
  getUploadedDocsForCurrentDriver,
  getUploadedDocsForMyDriver,
  getReferralCode,
  getHourlyWorkloads,
  getWorkloadSummary,
};
